<template>
  <div>
    <page-header
      title="Dynamic Numbering System"
      breadcrumb="Dashboard > Settings > Dynamic Numbering System > Edit Entity"
    />
   <div class="custom-card">
    <div class="flex justify-between">
      <div>
        <h3 class="font-semibold mb-2">Basic Details</h3>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">MODULE:</span>
            <span class="font-semibold inline-block w-2/3">Routes</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Entity:</span>
            <span class="font-semibold inline-block w-2/3">Route ID</span>
        </p>
        <p class="mb-2">
            <span class="text-sm inline-block text-lightGrey w-1/3">Description:</span>
            <span class="font-semibold inline-block w-2/3">Identification numbering for identifying routes uniquely.</span>
        </p>
      </div>
      <div class="flex flex-col items-center text-xs gap-2 p-1 text-lightGrey">
        <span class="gap-2 p-1 flex items-center rounded shadow cursor-pointer">
          <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 12C3.18629 12 0.5 9.31371 0.5 6C0.5 2.68629 3.18629 0 6.5 0C9.81371 0 12.5 2.68629 12.5 6C12.5 9.31371 9.81371 12 6.5 12ZM6.49998 10.9089C9.2112 10.9089 11.4091 8.71099 11.4091 5.99977C11.4091 3.28856 9.2112 1.09068 6.49998 1.09068C3.78876 1.09068 1.59089 3.28856 1.59089 5.99977C1.59089 8.71099 3.78876 10.9089 6.49998 10.9089ZM4.70394 8.56778L6.50006 6.77166L8.29618 8.56778L9.06757 7.79639L7.27145 6.00027L9.06757 4.20415L8.29618 3.43276L6.50006 5.22888L4.70394 3.43276L3.93255 4.20415L5.72867 6.00027L3.93255 7.79639L4.70394 8.56778Z" fill="#878E99"/>
          </svg>
          <span class="">HIDE</span>
        </span>
        <div class="flex flex-col gap-2 w-56 text-white py-4 px-2 rounded justify-center items-center text-center" style="background: #383F51;">
          <p>CODE PREVIEW</p>
          <p class="text-green text-center w-100 rounded p-2 bg-gray-200" style="background: #DAE8F6;">LK-CE-2020</p>
          <span class="bg-black p-1 cursor-pointer items-center flex text-sm gap-2">
            <span>
              <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.61111 0V1.11111H8.60556L3.14444 6.57222L3.92778 7.35556L9.38889 1.89444V3.88889H10.5V0H6.61111ZM9.38889 8.88889H1.61111V1.11111H5.5V0H1.61111C1.31643 0 1.03381 0.117063 0.825437 0.325437C0.617063 0.533811 0.5 0.816426 0.5 1.11111V8.88889C0.5 9.18357 0.617063 9.46619 0.825437 9.67456C1.03381 9.88294 1.31643 10 1.61111 10H9.38889C9.68357 10 9.96619 9.88294 10.1746 9.67456C10.3829 9.46619 10.5 9.18357 10.5 8.88889V5H9.38889V8.88889Z" fill="#F7F7FF"/>
              </svg>
            </span>
            <!-- <img src="@/assets/images/icons/external-link.svg" alt="external link icon">-->
            Learn About DNS 
          </span>
        </div>
      </div>
    </div>
    <div class="container ">
      <div class="row">
        <div class="col-md-6">
          <label class="label">Maximum Field Length</label>
          <el-select
            v-model="selectedCity"
            placeholder="-- Select or Input --"
          >
            <el-option
              label="city.name"
              value="city.name"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-md-6">
          <label class="label">First  Numbering Series</label>
          <input type="text" class="input" placeholder="--Enter--" />
        </div>
        <div class="col-md-6">
          <label class="label">Dynamic Number Increments</label>
          <input type="text" class="input" placeholder="--Enter--" />
        </div>
        <div class="col-md-6">
          <label class="label">Last Assigned Number</label>
          <input type="text" class="input" placeholder="--Enter--" />
        </div>
        <div class="col-md-6">
          <label class="label">Series Separator</label>
          <el-select
            v-model="selectedCity"
            placeholder="-- Select or Input --"
          >
            <el-option
              label="city.name"
              value="city.name"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <hr >
    <div class="flex gap-16 mt-4">
      <h3 class="font-semibold"> Prefix </h3>
      <el-switch
        v-model="value1"
        active-text="Enable"
        inactive-text="Disable">
      </el-switch>
      
    </div>
    <div class="route-type">
      <div class="route-type-options">
        <div class="single-option">
          <label for="international" class="radio-label label">
            <input
              type="radio"
              id="international"
              value="international"
              v-model="routeType"
            />
            Use Entity code Only
            <span></span>
          </label>
        </div>
        <div class="single-option">
          <label for="inter-state" class="radio-label label">
            <input
              type="radio"
              id="inter-state"
              value="inter-state"
              v-model="routeType"
            />
            Use Reference Code Only
            <span></span>
          </label>
        </div>
        <div class="single-option">
          <label for="intra-state" class="radio-label label">
            <input
              type="radio"
              id="intra-state"
              value="intra-state"
              v-model="routeType"
            />
            Use Both Entity and Reference Codes
            <span></span>
          </label>
        </div>
      </div>
    </div>
    <div class="container ">
      <div class="row">
        <div class="col-md-6">
          <label class="label">Entity Code</label>
          <input type="text" class="input" placeholder="--Enter--" />
        </div>
        <div class="col-md-6">
          <label class="label">Code Separator</label>
          <el-select
            v-model="selectedCity"
            placeholder="-- Select or Input --"
          >
            <el-option
              label="city.name"
              value="city.name"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <base-checkbox label="Include date in prefix" />
      <div class="route-type-options side-dot">
          <div class="single-option">
            <label for="international" class="radio-label label">
              <input
                type="radio"
                id="international"
                value="international"
                v-model="routeType"
              />
              Use a Date seperator
              <span></span>
            </label>
          </div>
          <div class="single-option">
            <label for="inter-state" class="radio-label label">
              <input
                type="radio"
                id="inter-state"
                value="inter-state"
                v-model="routeType"
              />
              Do not a use Date seperator
              <span></span>
            </label>
          </div>
        </div>
    </div>
    <div class="container ">
      <div class="row">
        <div class="col-md-6">
          <label class="label">Entity Code</label>
          <input type="text" class="input" placeholder="--Enter--" />
        </div>
        <div class="col-md-6">
          <label class="label">Date Format</label>
          <el-select
            v-model="selectedCity"
            placeholder="-- Select or Input --"
          >
            <el-option
              label="city.name"
              value="city.name"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-md-6">
          <label class="label">Date Separator (Dependent on Format)</label>
          <el-select
            v-model="selectedCity"
            placeholder="-- Select or Input --"
          >
            <el-option
              label="city.name"
              value="city.name"
            >
            </el-option>
          </el-select>
        </div>
        
      </div>
    </div>
    <hr>
    <div class="flex gap-16 mt-4">
      <h3 class="font-semibold"> Base String </h3>
      <el-switch
        v-model="value1"
        active-text="Enable"
        inactive-text="Disable">
      </el-switch>      
    </div>
    <div class="route-type">
      <div class="route-type-options">
        <div class="single-option">
          <label for="international" class="radio-label label">
            <input
              type="radio"
              id="international"
              value="international"
              v-model="routeType"
            />
            Use Entity code Only
            <span></span>
          </label>
        </div>
        <div class="single-option">
          <label for="inter-state" class="radio-label label">
            <input
              type="radio"
              id="inter-state"
              value="inter-state"
              v-model="routeType"
            />
            Use Reference Code Only
            <span></span>
          </label>
        </div>
        <div class="single-option">
          <label for="intra-state" class="radio-label label">
            <input
              type="radio"
              id="intra-state"
              value="intra-state"
              v-model="routeType"
            />
            Use Both Entity and Reference Codes
            <span></span>
          </label>
        </div>
      </div>
    </div>
    <div class="container ">
      <div class="row">
        <div class="col-md-6">
          <label class="label">Entity Code</label>
          <input type="text" class="input" placeholder="--Enter--" />
        </div>
        <div class="col-md-6">
          <label class="label">Reference Code</label>
          <el-select
            v-model="selectedCity"
            placeholder="-- Select or Input --"
          >
            <el-option
              label="city.name"
              value="city.name"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-md-6">
          <label class="label">Code Separator</label>
          <el-select
            v-model="selectedCity"
            placeholder="-- Select or Input --"
          >
            <el-option
              label="city.name"
              value="city.name"
            >
            </el-option>
          </el-select>
        </div>
        
      </div>
    </div>
    <div class="flex flex-col">
      <base-checkbox label="Include date in prefix" />
      <div class="route-type-options side-dot">
          <div class="single-option">
            <label for="international" class="radio-label label">
              <input
                type="radio"
                id="international"
                value="international"
                v-model="routeType"
              />
              Use a Date seperator
              <span></span>
            </label>
          </div>
          <div class="single-option">
            <label for="inter-state" class="radio-label label">
              <input
                type="radio"
                id="inter-state"
                value="inter-state"
                v-model="routeType"
              />
              Do not a use Date seperator
              <span></span>
            </label>
          </div>
        </div>
    </div>
    <div class="container ">
      <div class="row">
        <div class="col-md-6">
          <label class="label">Entity Code</label>
          <input type="text" class="input" placeholder="--Enter--" />
        </div>
        <div class="col-md-6">
          <label class="label">Date Format</label>
          <el-select
            v-model="selectedCity"
            placeholder="-- Select or Input --"
          >
            <el-option
              label="city.name"
              value="city.name"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-md-6">
          <label class="label">Date Separator (Dependent on Format)</label>
          <el-select
            v-model="selectedCity"
            placeholder="-- Select or Input --"
          >
            <el-option
              label="city.name"
              value="city.name"
            >
            </el-option>
          </el-select>
        </div>
        
      </div>
    </div>
    <hr>
    <div class="flex gap-16 my-4">
      <h3 class="font-semibold"> Suffix </h3>
      <el-switch
        v-model="value1"
        active-text="Enable"
        inactive-text="Disable">
      </el-switch>
    </div>
    <hr >
    <h3 class="font-semibold mt-4"> Activation </h3>
    <div class="route-type mb-4">
      <div class="route-type-options">
        <div class="single-option">
          <label for="international" class="radio-label label">
            <input
              type="radio"
              id="international"
              value="international"
              v-model="routeType"
            />
            Activate Now (Start Using this code format immediately
            <span></span>
          </label>
        </div>
        <div class="single-option">
          <label for="inter-state" class="radio-label label">
            <input
              type="radio"
              id="inter-state"
              value="inter-state"
              v-model="routeType"
            />
           Activate Later
            <span></span>
          </label>
        </div>
      </div>
    </div>
    <div class="flex gap-4 justify-end">
      <base-button border="border" borderColor="border-gray-500" background="#fff" text="Cancel " />
      <base-button text="Save" />
    </div>
   </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
export default {
  components: {
    PageHeader
  },
  data() {
    return {
      routeType: '',
      value1: ""
    }
  },
};
</script>

<style lang="scss" scoped>
.route-type {
  display: flex;
  flex-wrap: wrap;
  margin: 1rem 0;
  p {
    padding-right: 2rem;
  }
}
.route-type-options {
  display: flex;
  flex-wrap: wrap;
  .single-option {
    padding-right: 1.5rem;
  }
}
.side-dot{
  margin:0.6rem;
  border-left: 1px dashed #878E99;
  padding-left: 1em;
}
</style>